export default __webpack_public_path__ + "static/media/product_card_Cn.ccd0302f.webp";